export default function Django_Templates() {
  return <div>Django_Templates Component</div>;
}
